import { useQuery } from '@tanstack/react-query';

import {
  companiesService,
  FetchOrdersRequest,
  FetchOrdersResponse,
  individualsService,
  ordersService,
} from '@aslanpay/portal-common-lib';

const useFetchOrdersPage = ({
  ids,
  types,
  statuses,
  paymentMethods,
  sortBy,
  sort,
  page,
  size,
}: FetchOrdersRequest) => {
  return useQuery<FetchOrdersResponse, Error>(
    ['fetchOrdersPage', ids, statuses, page, size, sortBy, sort],
    async () => {
      const orders = await ordersService.fetchOrders({
        ids,
        types,
        statuses,
        paymentMethods,
        page,
        size,
        sortBy,
        sort,
      });

      const companies = await companiesService.fetchCompanies({
        ids: orders.list.map((order) => order.companyId),
        page: 0,
        size: 999999,
      });

      let ordersList = orders.list.map((order) => {
        const company = companies.list.find((comp) => comp.id === order.companyId);
        return {
          ...order,
          companyName: company ? company.name : 'undefined',
        };
      });

      const individualIds = orders.list
        .map((order) => order.completedBy || order.archivedBy || order.cancelledBy)
        .filter((id) => id !== undefined);

      if (individualIds.length === 0) {
        return { ...orders, list: ordersList };
      }

      const individuals = await individualsService.fetchIndividuals({
        ids: individualIds,
        page: 0,
        size: 999999,
      });

      ordersList = ordersList.map((order) => {
        const completedByIndividual = individuals.list.find((ind) => ind.id === order.completedBy);
        const archivedByIndividual = individuals.list.find((ind) => ind.id === order.archivedBy);
        const cancelledByIndividual = individuals.list.find((ind) => ind.id === order.cancelledBy);

        return {
          ...order,
          completedByName: completedByIndividual
            ? `${completedByIndividual.firstName} ${completedByIndividual.lastName}`
            : 'undefined',
          archivedByName: archivedByIndividual
            ? `${archivedByIndividual.firstName} ${archivedByIndividual.lastName}`
            : 'undefined',
          cancelledByName: cancelledByIndividual
            ? `${cancelledByIndividual.firstName} ${cancelledByIndividual.lastName}`
            : 'undefined',
        };
      });

      return { ...orders, list: ordersList };
    }
  );
};

export default useFetchOrdersPage;
